import { render, staticRenderFns } from "./PasswordResetActionComponent.vue?vue&type=template&id=3021fa28&"
import script from "./PasswordResetActionComponent.vue?vue&type=script&lang=js&"
export * from "./PasswordResetActionComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports